export interface IVehicleTypes {
  vehicleTypeId: number;
  orgVehicleTypeMapId: number;
  mileageRate: number;
}

export class VehicleTypes implements IVehicleTypes {
  vehicleTypeId: number;
  orgVehicleTypeMapId: number;
  mileageRate: number;
  //constructor(vehicleTypeId: number,
  //  orgVehicleTypeMapId: string,
  //  mileageRate: number) {
  //  this.vehicleTypeId = vehicleTypeId;
  //  this.orgVehicleTypeMapId = orgVehicleTypeMapId;
  //  this.mileageRate = mileageRate;
  //}
}

export interface IBasicMileageHistory {
  vehicleTypeId: number;
  oldMileageRate: number;
  newMileageRate: number;
  oldMileageUOM: number;
  newMileageUOM: number;
  notes: string;
}


export class BasicMileageHistory implements IBasicMileageHistory {
  vehicleTypeId: number;
  oldMileageRate: number;
  newMileageRate: number;
  oldMileageUOM: number;
  newMileageUOM: number;
  notes: string;
  //constructor(vehicleTypeId: number,
  //  oldMileageRate: number,
  //  newMileageRate: number,
  //  oldMileageUOM: number,
  //  newMileageUOM: number,
  //  notes: string) {
  //  this.vehicleTypeId = vehicleTypeId;
  //  this.oldMileageRate = oldMileageRate;
  //  this.newMileageRate = newMileageRate;
  //  this.oldMileageUOM = oldMileageUOM;
  //  this.newMileageUOM = newMileageUOM;
  //  this.notes = notes;
  //}
}


export class AssignVehicleDefaultFormModel {
  vehicleId: number;
}

export class AssignNewDefaultVehicleInputModel {
  public vehicleList: IUserVehicleListDetails[];
  public userId: number;
  public rateType: number;
  public oldVehicle: IUserVehicleListDetails;
}

export interface IAssignVehicleDetails {
  userId: number;
  employeeCode: string;
  displayName: string;
  firstName: string;
  lastName: string;
  email: string;
  vehicleType: string;
  vehicleTypeId: number;
  orgVehicleTypeMapId: number;
  selected: boolean;
  updatedOn: any;
  isRowHighlighted: boolean;
  derivedName: string;
  milesDone: number;
  vehicleStatusName: string;
  vehicleStatus: number;
  openingBalance: number;
  vehicleSubTypeId: number;
  averageMiles: number;
  vehicleId: number;
  pageType: number;
  userVehicleList: IUserVehicleListDetails[];
  vehicleCount: VehicleCount[];
  oldVehicleStatus: number;
  isDefault: boolean;
  startDate:number;
  nrFCStatus:number;
  
}


export class AssignVehicleDetails implements IAssignVehicleDetails {
  userId: number;
  employeeCode: string;
  displayName: string;
  firstName: string;
  lastName: string;
  email: string;
  vehicleType: string;
  vehicleTypeId: number;
  orgVehicleTypeMapId: number;
  selected: boolean;
  updatedOn: any;
  isRowHighlighted: boolean;
  derivedName: string;
  milesDone: number;
  vehicleStatusName: string;
  vehicleStatus: number;
  openingBalance: number;
  vehicleSubTypeId: number;
  averageMiles: number = 0;
  vehicleId: number;
  pageType: number;
  userVehicleList: IUserVehicleListDetails[];
  vehicleCount: VehicleCount[];
  oldVehicleStatus: number;
  isDefault: boolean;
  startDate:number;
  nrFCStatus:number;
  
  constructor() {
    this.selected = false;
  }
}

export interface IUserVehicleListDetails {
  vehicleId: number;
  derivedName: string;
  registrationNumber: string;
  makeModel: string;
  isDefault: boolean;
  averageMiles: number;
  openingBalance: number;
  vehicleStatus: number;
  vehicleTypeId: number;
  orgVehicleTypeMapId: number;
  vehicleSubType: number;
  vehicleCreationDate: number;
  deleteDate: any;
  milesDone: number;
  docId:number;
  docStatus: number;
  mileageRate: string;
  hideActions: boolean;
  startDate: any;
  mileageRateHistory: string;
  isFirstCar:boolean;
}

export class UserVehicleListDetails implements IUserVehicleListDetails {
  vehicleId: number;
  derivedName: string;
  registrationNumber: string;
  makeModel: string;
  isDefault: boolean;
  averageMiles: number;
  openingBalance: number;
  vehicleStatus: number;
  vehicleTypeId: number;
  orgVehicleTypeMapId: number;
  vehicleSubType: number;
  vehicleCreationDate: number;
  deleteDate: any;
  milesDone: number;
  docId:number;
  docStatus: number;
  mileageRate: string;
  hideActions: boolean;
  startDate: any;
  mileageRateHistory: string;
  isFirstCar:boolean;
}


export class VehicleCount {
  status: number;
  count: number;
}

